import React, { useMemo } from 'react'
import { Label } from '@therms/atalaya'
import {
  DateTime,
  RefsByTypeTitles,
  ReportStateBadge,
  RPCDocs,
} from '@therms/react-modules'
import { flatten } from 'lodash-es'

interface Props {
  report: RPCDocs.Reports.GetReport.v1.Report
}

function ReportDetailsSection({ report }: Props) {
  const showRefs = useMemo(
    () => flatten(Object.values(report.refsByType)).length > 0,
    [report],
  )

  return (
    <div>
      <div>
        <Label>Date</Label> <DateTime mode="date" timestamp={report.date} />
      </div>

      {showRefs && (
        <div>
          <Label>Refs</Label>{' '}
          <RefsByTypeTitles refsByType={report.refsByType} />
        </div>
      )}

      <div>
        <Label>Status</Label> <ReportStateBadge state={report.state} />{' '}
        {report.status.title}
      </div>

      <div>
        <Label>Authors</Label>{' '}
        <span>
          {report.authors?.map(({ displayName }) => displayName).join(', ')}
        </span>
      </div>
    </div>
  )
}

export { ReportDetailsSection }
